<template>
  <div class="work-order-detail">
    <div class="big-img" v-if="activeBigImg">
      <div class="close-img">
        <img :src="bigImgUrl" alt="" class="des-img" />
        <img
          src="../../assets/img/close.png"
          alt=""
          class="close"
          @click="closeBigImg"
        />
      </div>
    </div>
    <div class="left">
      <div class="left-top">
        <!-- 我创建的 新建 开始处理 驳回处理 1 2 4-->
        <div
          class="status-but"
          v-if="activeColor == 1 && [1, 2, 4].indexOf(detailData.status) > -1"
        >
          <el-button size="small" @click="changeState(0)">关 闭</el-button>
        </div>
        <!-- 我创建的 已处理 3 -->
        <div
          class="status-but"
          v-if="activeColor == 1 && detailData.status == 3"
        >
          <el-button size="small" @click="changeState(99)"
            >确认已解决</el-button
          >
          <el-button size="small" @click="changeState(4)">未解决</el-button>
        </div>
        <!-- 我受理的 新建 开始处理 1 2 -->
        <!--        <div class="status-but" v-if="activeColor == 2 && [1,2,4].indexOf(detailData.status) > -1">-->
        <!--          <el-button size="small" @click="changeState(3)">已解决</el-button>-->
        <!--        </div>-->
        <h3 class="left-title">
          工单号 <span class="order-num">{{ detailData.exceptionOrderNo }}</span
          ><img src="./../../assets/img/connaction.png" alt="" /><span
            class="connect-num"
            @click="goOrder(detailData.businessKey)"
            >{{ detailData.businessKey }}</span
          >
        </h3>
        <div class="status">
          处理状态： <span class="doing">{{ detailData.statusDesc }}</span>
        </div>
        <div class="type">
          工单类型： <span>{{ detailData.exceptionTypeDesc }}</span>
        </div>
        <div class="des">
          <div class="des-title">工单描述：</div>
          <div class="des-content">{{ detailData.description }}</div>
        </div>
        <div class="img">
          图片说明：
          <img
            :src="item"
            alt=""
            v-for="(item, index) of detailData.exceptionImageUrls"
            :key="index"
            @click="bigImg(index)"
          />
        </div>
        <div class="img">
          视频说明：
          <div v-if="detailData.videoList && detailData.videoList.length > 0">
            <video
              v-for="(item, index) of detailData.videoList"
              v-bind:src="item"
              class="avatar video-avatar"
              controls="controls"
              style="width: 128px; margin-right: 10px;"
            >
              您的浏览器不支持视频播放
            </video>
          </div>
          <!-- <video
            src="http://1302890022.vod2.myqcloud.com/8fd2a0e4vodsh1302890022/a1e8f9bf5576678022672400250/HeK9QXudwyMA.mp4"
            class="avatar video-avatar"
            controls="controls"
            style="width: 100px;"
          >
            您的浏览器不支持视频播放
          </video> -->
        </div>
        <div class="lastAddImg">
          <span>补充图片：</span>
          <el-upload
            class="img-upload"
            :action="addImgUrl"
            :headers="headers"
            list-type="picture-card"
            :auto-upload="true"
            :limit="5"
            :before-upload="beforeAvatarUpload"
            :on-success="successImg"
            :file-list="fileList"
            :on-exceed="exce"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!build.disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file, fileList)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog
            :visible.sync="build.dialogVisible"
            :modal="true"
            :modal-append-to-body="false"
          >
            <img width="100%" :src="build.dialogImageUrl" alt="" />
          </el-dialog>
          <el-dialog
            :visible.sync="deleteDialogVisible"
            width="400px"
            :modal="true"
            :modal-append-to-body="false"
            :show-close="false"
            custom-class="delete-modal"
          >
            <span
              ><i class="el-icon-warning-outline warning-icon"></i
              >是否确认删除当前图片？</span
            >
            <span slot="footer" class="dialog-footer">
              <el-button @click="deleteDialogVisible = false" size="small"
                >取 消</el-button
              >
              <el-button type="primary" @click="sureDelete" size="small"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>
        <div class="img-info">（最多支持上传5张）</div>
        <div class="people">
          <div class="time-line">
            <span class="span1"></span><span class="span2"></span
            ><span class="span3"></span>
          </div>
          <div class="end">
            最终受理人 <img src="./../../assets/img/user-icon.png" alt="" />
            <div class="name">{{ detailData.operatorName }}</div>
            <div class="time" v-if="detailData.resolutionTime">
              <span>解决时间</span> {{ detailData.resolutionTime }}
            </div>
          </div>
          <div class="first">
            第一受理人 <img src="./../../assets/img/user-icon.png" alt="" />
            <div class="name">{{ detailData.operatorName }}</div>
          </div>
          <div class="build">
            创建人 <img src="./../../assets/img/user-icon.png" alt="" />
            <div class="name">{{ detailData.createdByName }}</div>
            <div class="time">
              <span>创建时间</span> {{ detailData.createdAt }}
            </div>
          </div>
        </div>
      </div>
      <div class="left-bottom">
        <h3>活动日志</h3>
        <div class="inp">
          <el-autocomplete
            v-model="activeContent"
            :fetch-suggestions="querySearch"
            placeholder="请输入备注内容"
            @select="handleSelect"
          >
            <template slot-scope="{ item }">
              <span :title="item">{{ item }}</span>
            </template>
          </el-autocomplete>
          <el-button size="small" @click="addRemarkContent">确 定</el-button>
        </div>
        <div class="active-list">
          <div
            class="list"
            v-for="(item, index) of detailData.operations"
            :key="index"
          >
            <img src="./../../assets/img/user-icon.png" alt="" />
            <div class="name">{{ item.operatorName }}</div>
            <div class="time">{{ item.createdAt }}</div>
            <div class="content">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getWorkOrderDetail,
  addRemark,
  changeStatus,
  getAsOrderInfo,
  additionalImage,
  deleteImage,
  exceptionOrderReply
} from "@/models/exceptionModel";

export default {
  data() {
    return {
      activeColor: null,
      activeContent: "",
      detailData: {},
      bigImgUrl: "",
      activeBigImg: false,
      // 2021-12-03 补充图片
      imgArr: null,
      addImgUrl: `${additionalImage}/additional-commonFile/${this.$route.query.exceptionOrderNo}`,
      headers: {
        Authorization: localStorage.getItem("token")
      },
      fileList: [],
      replyList: [],
      build: {
        dialogImageUrl: [],
        dialogVisible: false,
        disabled: false
      },
      deleteDialogVisible: false
    };
  },
  created() {
    // console.log(this.$route.query.exceptionOrderNo);
    let exceptionOrderNo = this.$route.query.exceptionOrderNo;
    this.activeColor = this.$route.query.activeColor;
    getWorkOrderDetail(exceptionOrderNo)
      .then(res => {
        this.detailData = res || {};
        // 补充图片的回显
        if (res.additionalImgs && res.additionalImgs.length) {
          res.additionalImgs.map(item => {
            this.fileList.push({ url: item });
          });
        }
        if (this.detailData.exceptionType != "") {
          this.loadReply();
        }
      })
      .catch(err => {
        console.log(err);
        this.$message.error(err.message);
      });
  },
  methods: {
    handleSelect(item) {
      this.activeContent = item;
    },
    querySearch(queryString, cb) {
      const restaurant = this.replyList;
      cb(restaurant);
    },
    loadReply() {
      const params = {
        currentSystem: 5,
        secondWorkOrderId: this.detailData.exceptionType
      };
      exceptionOrderReply(params)
        .then(res => {
          this.replyList = res || [];
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    addRemarkContent() {
      if (this.activeContent.trim()) {
        let params = {
          content: this.activeContent.trim(),
          exceptionOrderNo: this.detailData.exceptionOrderNo,
          operatorId: localStorage.getItem("supplier_id"),
          operatorName: localStorage.getItem("username")
        };
        addRemark(params)
          .then(res => {
            // console.log(res);
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.activeContent = "";
            // 活动日志重新请求渲染
            getWorkOrderDetail(params.exceptionOrderNo)
              .then(res => {
                // console.log(res);
                this.detailData = res;
              })
              .catch(err => {
                console.log(err);
                this.$message.error(err.message);
              });
          })
          .catch(err => {
            console.log(err);
            this.$message.error(err.message);
          });
      } else {
        this.activeContent = "";
      }
    },
    changeState(status) {
      if (status === 0) {
        this.$prompt("关闭售后说明", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "textarea",
          roundButton: true,
          inputPlaceholder: "请务必输入关单原因!!!"
          // 不能为空的正则表达式
          // inputPattern:/^.+$/,
          // inputPattern:/\s/,
          // inputPattern:/^\\s\\r\\n/,
          // inputErrorMessage: '请填写说明!'
        }).then(({ value }) => {
          // console.log(value);
          if (value == null) {
            this.$message.warning("关单原因不能为空!");
          } else if (value.trim().length) {
            let params = {
              exceptionOrderNo: this.detailData.exceptionOrderNo,
              operatorId: localStorage.getItem("supplier_id"),
              operatorName: localStorage.getItem("username"),
              status: status,
              reason: value
            };
            changeStatus(params)
              .then(res => {
                // console.log(res);
                this.detailData.status = status;
                // 活动日志重新请求渲染
                getWorkOrderDetail(params.exceptionOrderNo)
                  .then(res => {
                    // console.log(res);
                    this.detailData = res;
                  })
                  .catch(err => {
                    console.log(err);
                    this.$message.error(err.message);
                  });
              })
              .catch(err => {
                console.log(err);
                this.$message.error(err.message);
              });
          } else {
            this.$message.warning("关单原因不能为空!");
          }
        });
      } else {
        let params = {
          exceptionOrderNo: this.detailData.exceptionOrderNo,
          operatorId: localStorage.getItem("supplier_id"),
          operatorName: localStorage.getItem("username"),
          status: status
        };
        // 二次确认：释放167-197行代码
        // this.$confirm('此操作将修改工单状态,是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(async () => {
        //   // let data = await changeStatus(params)
        //   // console.log(data);
        //   // if (data.message === 'Success') {
        //     this.$message.success('状态更改成功')
        //     changeStatus(params).then(res => {
        //       // console.log(res);
        //       this.detailData.status = status
        //       // 活动日志重新请求渲染
        //       getWorkOrderDetail(params.exceptionOrderNo).then(res => {
        //         // console.log(res);
        //         this.detailData = res
        //       }).catch(err => {
        //         console.log(err);
        //         this.$message.error(err.message);
        //       })
        //     }).catch(err => {
        //       console.log(err);
        //       this.$message.error(err.message);
        //     })
        //   // }
        // }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: '已取消更改'
        //   })
        // })
        changeStatus(params)
          .then(res => {
            // console.log(res);
            this.detailData.status = status;
            // 活动日志重新请求渲染
            getWorkOrderDetail(params.exceptionOrderNo)
              .then(res => {
                // console.log(res);
                this.detailData = res;
              })
              .catch(err => {
                console.log(err);
                this.$message.error(err.message);
              });
          })
          .catch(err => {
            console.log(err);
            this.$message.error(err.message);
          });
      }
    },
    bigImg(index) {
      this.bigImgUrl = this.detailData.exceptionImageUrls[index];
      this.activeBigImg = true;
    },
    closeBigImg() {
      this.bigImgUrl = "";
      this.activeBigImg = false;
    },
    goOrder(businessKey) {
      console.log(businessKey);
      getAsOrderInfo(businessKey)
        .then(res => {
          console.log(res);
          // orderType 是否大客户订单:0=否,1=是
          if (res.orderType === 1) {
            this.$router.push({
              path: `/bigAftersale/manage`,
              query: { businessKey: businessKey }
            });
          } else if (res.orderType === 0) {
            this.$router.push({
              path: `/afterSale/manage`,
              query: { businessKey: businessKey }
            });
          } else if (res.orderType === -1) {
            this.$message.info("无此售后单信息");
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    //上传时，判断文件的类型及大小是否符合规则
    beforeAvatarUpload(file) {
      const isJPG =
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.warning("上传头像图片只能是 JPG/PNG/GIF 格式!");
        return isJPG;
      }
      if (!isLt2M) {
        this.$message.warning("上传头像图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isJPG && isLt2M;
    },
    successImg(res, file) {
      // console.log(res,file, 'suc');
      // this.imgArr.push(file.response.data)
      this.fileList.push(file);
      // console.log(this.fileList);
    },
    exce() {
      this.$message.warning("最多上传5张图片");
    },
    // 删除按钮
    handleRemove(file, fileList) {
      this.deleteDialogVisible = true;
      this.imgArr = file;
      // this.imgArr = this.imgArr.filter(item => {
      //   return item != file.response.data
      // })
      // const filePath = file.url
      // const i = this.fileList.findIndex(x => x.url === filePath)
      // this.fileList.splice(i, 1)
      // console.log('删除按钮',file, fileList);
    },
    sureDelete() {
      // this.imgArr = this.imgArr.filter(item => {
      //   return item != file.response.data
      // })
      // 页面显示删除
      const filePath = this.imgArr.url;
      const i = this.fileList.findIndex(x => x.url === filePath);
      this.fileList.splice(i, 1);
      // 走接口删除
      deleteImage(this.$route.query.exceptionOrderNo, this.imgArr.url)
        .then(res => {
          console.log(res);
          this.$message({
            message: "删除成功",
            type: "success"
          });
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err.message);
        });
      this.deleteDialogVisible = false;
    },
    handlePictureCardPreview(file) {
      this.build.dialogImageUrl = file.url;
      this.build.dialogVisible = true;
    }
  },
  filters: {
    statusFilter(value) {
      const valueObj = {
        0: "已撤销",
        1: "新建",
        2: "开始处理",
        3: "已处理",
        4: "驳回处理",
        99: "已完成"
      };
      return valueObj[value];
    }
  }
};
</script>

<style scoped lang="scss">
.left {
  width: 60%;
  min-width: 652px;
  font-size: 14px;
  padding-left: 10px;
  .left-top {
    position: relative;
    .status-but {
      position: absolute;
      right: 0;
      button {
        border-radius: 20px;
        color: #fff;
      }
    }
  }
  .left-title {
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
    img {
      width: 18px;
      height: 18px;
      margin-right: 5px;
    }
  }
  .order-num {
    margin: 0 15px;
  }
  .connect-num {
    color: #ff6224 !important;
    cursor: pointer;
  }
  .doing {
    background-color: #ff6224;
    padding: 5px 10px;
    border-radius: 3px;
    color: #fff;
    font-size: 12px;
    margin-left: 10px;
  }
  .type {
    margin: 15px 0;
    span {
      font-weight: bold;
      margin-left: 10px;
    }
  }
  .des {
    display: flex;
    line-height: 25px;
    .des-title {
      width: 70px;
      // line-height: 50px;
    }
    .des-content {
      // line-height: 25px;
      width: 500px;
      margin-left: 15px;
    }
  }
  .img {
    margin: 15px 0 25px;
    display: flex;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
      margin-left: 15px;
      border-radius: 3px;
      cursor: pointer;
    }
  }
  .people {
    background-color: #f5f7fa;
    border-radius: 10px;
    padding: 20px 20px 20px 60px;
    position: relative;
    div {
      position: relative;
      line-height: 50px;
      .name {
        position: absolute;
        left: 145px;
        top: 0;
      }
      .time {
        position: absolute;
        left: 350px;
        top: 0;
        span {
          margin-right: 20px;
        }
      }
      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        position: absolute;
        left: 108px;
        top: 9px;
      }
    }
    .time-line {
      width: 3px;
      height: 117px;
      position: absolute;
      left: 30px;
      top: 37px;
      background-color: #ff6224;
      span {
        width: 9px;
        height: 9px;
        background-color: #ff6224;
        border: 3px solid #fff;
        position: absolute;
        top: 0px;
        left: -6px;
        border-radius: 25px;
      }
      .span2 {
        top: 50px;
      }
      .span3 {
        top: 102px;
      }
    }
  }
}
.left-bottom {
  position: relative;
  margin-top: 25px;
  .inp {
    position: absolute;
    top: -8px;
    right: 0;
    display: flex;
    /deep/ .el-input__inner {
      border-radius: 30px !important;
      width: 350px;
      margin-right: 15px;
      height: 35px;
      line-height: 35px;
    }
    .el-button {
      color: #fff;
      border-radius: 30px;
      padding: 0 20px;
    }
  }
  .active-list {
    padding: 20px 20px 2px;
    background-color: #f5f7fa;
    border-radius: 10px;
    margin-top: 25px;
    .list {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
      .name {
        width: 140px;
        margin: 0 15px;
      }
      .time {
        width: 200px;
      }
      .content {
        width: 60%;
      }
    }
  }
}
/deep/ .el-input__inner:focus {
  border-color: #ff6224;
}

.big-img {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.3);
  .close-img {
    // width: 480px;
    // height: 480px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 20px;
    padding: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    .des-img {
      // width: 450px;
      // height: 450px;
      max-height: 70vh;
      max-width: 80vw;
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
  }
}
/deep/ .delete-modal {
  .el-dialog__header {
    height: 0 !important;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__footer {
    text-align: right;
  }
}
.lastAddImg {
  display: flex;
  > span {
    margin-right: 15px;
  }
  .warning-icon {
    font-size: 18px;
    color: #ff6224;
    margin-right: 5px;
  }
}
.img-info {
  margin-left: 76px;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderForChat/workOrderDetail.vue